import { Button, Checkbox, CheckboxGroup, Input, Select, SelectItem, Textarea } from '@nextui-org/react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../../assets/images/logo_klhk.png';
import RootAuth from '../../components/layouts/RootAuth';
import { useState } from 'react';
import { getFetcherPublic, postMultipartFetcher, uploadPhoto } from '../../services/api';
import { Controller, useForm } from "react-hook-form";
import toast from 'react-hot-toast';
import { LOGIN_PATH } from '../../services/routes';
import useSWR from 'swr';
import { isResponseErrorObject } from '../../services/helpers';
import ControlledReactSelect from '../../components/elements/ControlledReactSelect';
import ControlledInput from '../../components/elements/ControlledInput';

export default function RegisterPage() {
    const [uploadStatus, setUpload] = useState({});
    const [isVisible, setIsVisible] = useState(false);
    const { register, handleSubmit, watch, reset, control, formState: { errors, isSubmitting }, setValue } = useForm();
    const navigate = useNavigate();
    const provinceId = watch('provinceId');
    const regencyId = watch('regencyId');
    const districtId = watch('districtId');
    const provinceIdPendaftar = watch('provinceIdPendaftar');

    const { data: provincePendaftar } = useSWR('api/location/public/provinces', getFetcherPublic)
    const { data: regencyPendaftar } = useSWR(provinceIdPendaftar ? `api/location/public/cities?provinceId=${provinceIdPendaftar}` : null, getFetcherPublic)

    const { data: province } = useSWR('api/location/public/provinces', getFetcherPublic)
    const { data: regency } = useSWR(provinceId ? `api/location/public/cities?provinceId=${provinceId}` : null, getFetcherPublic)
    const { data: district } = useSWR(regencyId ? `/api/location/public/districts?regencyId=${regencyId}`: null, getFetcherPublic)
    const { data: village } = useSWR(districtId ? `/api/location/public/villages?districtId=${districtId}`: null, getFetcherPublic)

    const tipePerusahaan = watch("tipePerusahaan");

    const toggleVisibility = () => setIsVisible(!isVisible);

    async function onSubmit(data) {
        try {
            const formDataToSend = new FormData();
            formDataToSend.append("fullName", data.fullName);
            formDataToSend.append("email", data.email);
            formDataToSend.append("phoneNumber", data.phoneNumber);
            formDataToSend.append("provinceIdPendaftar", data.provinceIdPendaftar);
            formDataToSend.append("regencyIdPendaftar", data.regencyIdPendaftar);
            formDataToSend.append("address", data.address);
            formDataToSend.append("idNumber", data.idNumber);
            formDataToSend.append("alamatKantor", data.alamatKantor);
            formDataToSend.append("provinceId", data.provinceId);
            formDataToSend.append("regencyId", data.regencyId);
            formDataToSend.append("districtId", data.districtId);
            formDataToSend.append("villageId", data.villageId);
            formDataToSend.append("name", data.name);
            formDataToSend.append("emailKantor", data.emailKantor);
            data?.tipePerusahaan?.forEach((tipe) => {
                formDataToSend.append("tipePerusahaan[]", tipe);
              });
            formDataToSend.append("telpKantor", data.telpKantor);
            formDataToSend.append("npwp", data.npwp);
            formDataToSend.append("bidangUsaha", data.bidangUsaha);
            formDataToSend.append("nomorInduk", data.nomorInduk);
            formDataToSend.append("latitude", data.latitude);
            formDataToSend.append("longitude", data.longitude);
            formDataToSend.append("namaPenanggungJawab", data.namaPenanggungJawab   );
            formDataToSend.append("jabatan", data.jabatan);
            formDataToSend.append("emailDirektur", data.emailDirektur);
            formDataToSend.append("teleponDirektur", data.teleponDirektur);
            formDataToSend.append("alamatDirektur", data.alamatDirektur);
            if (data?.tipePerusahaan?.includes("Distribusi B3")){   
                formDataToSend.append("skalaPerusahaan", data.skalaPerusahaan);
            }
            data.attachments.forEach((file, index) => {
                if (file instanceof File) {    
                    console.log(`Appending file ${index + 1}:`, file);
                                    
                    formDataToSend.append('attachments', file)
                } else {
                    console.error('Invalid file object:', file)
                }
            });
            
            await postMultipartFetcher('/api/auth/new-register',formDataToSend)
            toast.success('Berhasil membuat akun silahkan menunggu verifikasi admin dan periksa email!')
            reset();
            // navigate(LOGIN_PATH, { replace: true })
        } catch (error) {
            isResponseErrorObject(error.response.data.message)
                ? Object.entries(error.response.data.message).forEach(([key, value]) => {
                    toast.error(value)
                })
                : toast.error(error.response.data.message)

        }
    }

    return (
        <RootAuth>
            <div className="relative w-full flex flex-col p-5 md:p-24 m-5 lg:m-0 bg-white shadow-md lg:shadow-none rounded-xl lg:rounded-none">
                <div className="text-center lg:text-start">
                    <img src={logo} alt="Logo" className="size-20 mx-auto lg:mx-0"/>
                    <h3 className="font-bold text-2xl mt-5">Daftarkan Akun Disini</h3>
                    <div className="mt-4 flex items-center gap-1 justify-center lg:justify-start text-base">
                        <span className="text-center">Sudah Punya Akun?</span>
                        <Link to={LOGIN_PATH} className="text-primary hover:underline">Login Disini</Link>
                    </div>
                </div>

                <form className="pt-10 font-medium" onSubmit={handleSubmit(onSubmit)}>
                    <div>
                        <h4 className="text-lg font-bold">Data Pendaftar</h4>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 gap-4 mb-5">
                        <Input
                            {...register('fullName')}
                            color={errors.fullName ? 'danger' : 'default'}
                            isInvalid={errors.fullName}
                            errorMessage={errors.fullName && errors.fullName.message}
                            radius="sm"
                            label="Nama Lengkap"
                            labelPlacement="outside"
                            type="text"
                            size="md"
                            placeholder='Masukan nama lengkap'
                        />
                        <Input
                            {...register('email')}
                            color={errors.email ? 'danger' : 'default'}
                            isInvalid={errors.email}
                            errorMessage={errors.email && errors.email.message}
                            radius="sm"
                            label="Email"
                            labelPlacement="outside"
                            type="email"
                            size="md"
                            placeholder='Masukan email'
                        />
                        <Input
                            {...register('phoneNumber')}
                            color={errors.phoneNumber ? 'danger' : 'default'}
                            isInvalid={errors.phoneNumber}
                            errorMessage={errors.phoneNumber && errors.phoneNumber.message}
                            radius="sm"
                            label="Telepon"
                            labelPlacement="outside"
                            type="text"
                            size="md"
                            placeholder='Masukan telepon'
                        />
                        <Select
                            {...register('provinceIdPendaftar', { required: 'Province is required' })}
                            color={errors.provinceIdPendaftar ? 'danger' : 'default'}
                            isInvalid={errors.provinceIdPendaftar}
                            errorMessage={errors.provinceIdPendaftar && errors.provinceIdPendaftar.message}
                            radius="sm"
                            label="Provinsi"
                            labelPlacement="outside"
                            size="md"
                            placeholder='Pilih provinsi'
                            onChange={(e) => setValue('provinceIdPendaftar', e.target.value)}
                        >
                            {provincePendaftar?.map(item => (
                                <SelectItem key={item.id}>{item.name}</SelectItem>
                            ))}
                        </Select>
                        <Select
                            {...register('regencyIdPendaftar', { required: 'City is required' })}
                            color={errors.regencyIdPendaftar ? 'danger' : 'default'}
                            isInvalid={errors.regencyIdPendaftar}
                            errorMessage={errors.regencyIdPendaftar && errors.regencyIdPendaftar.message}
                            radius="sm"
                            label="Kota / Kabupaten"
                            labelPlacement="outside"
                            size="md"
                            placeholder='Pilih kota / kabupaten'
                        >
                            {regencyPendaftar?.map(it => (
                                <SelectItem key={it.id} value={it.id}>{it.name}</SelectItem>
                            ))}
                        </Select>
                    </div>
                    <Textarea
                        {...register('address', { required: "address is required" })}
                        color={errors.address ? 'danger' : 'default'}
                        isInvalid={errors.address}
                        errorMessage={errors.address && errors.address.message}
                        radius="sm"
                        label="Alamat"
                        labelPlacement="outside"
                        fullWidth
                        disableAutosize
                    />
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 gap-4 mt-5 mb-5">
                        <Input
                            {...register('idNumber', { required: "idNumber is required" })}
                            color={errors.idNumber ? 'danger' : 'default'}
                            isInvalid={errors.idNumber}
                            errorMessage={errors.idNumber && errors.idNumber.message}
                            radius="sm"
                            label="Nomor KTP"
                            labelPlacement="outside"
                            type="text"
                            size="md"
                            placeholder='Masukan nomor ktp'
                        />
                        {/* <Input
                            {...register('attachments', { required: "attachments is required" })}
                            color={errors.attachments ? 'danger' : 'default'}
                            isInvalid={errors.attachments}
                            errorMessage={errors.attachments && errors.attachments.message}
                            radius="sm"
                            label="File KTP"
                            labelPlacement="outside"
                            type="file"
                            size="md"
                            onChange={handleFileUpload}
                        />
                        <Input
                            {...register('password', { required: "Password is required"})}
                            color={errors.password ? 'danger' : 'default'}
                            isInvalid={errors.password}
                            errorMessage={errors.password && errors.password.message}
                            radius="sm"
                            className="pb-5"
                            type={ isVisible ? "text" : "password" }
                            size="md"
                            label="Password"
                            labelPlacement="outside"
                            placeholder='*********'
                            endContent={
                                <Button size='sm' isIconOnly onClick={ toggleVisibility }>
                                    { isVisible ? <EyeSlashIcon className="size-4" /> : <EyeIcon className="size-4" /> }
                                </Button>
                            }
                        />
                        <Input
                            {...register('confirmPassword', {
                            required: "Confirm Password is required",
                            validate: (value) =>
                                value === getValues('password') || "Password do not match"
                            })}
                            color={errors.confirmPassword ? 'danger' : 'default'}
                            isInvalid={errors.confirmPassword}
                            errorMessage={errors.confirmPassword && errors.confirmPassword.message}
                            radius="sm"
                            label="Konfirmasi Password"
                            labelPlacement="outside"
                            type={ isVisible ? "text" : "password" }
                            size="md"
                            placeholder='*********'
                        /> */}
                    </div>
                    </div>
                    <div>
                        <h4 className="text-lg font-bold">Data Perusahaan</h4>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 gap-4 mb-5">
                        <ControlledInput control={control} name="name" label="Nama Perusahaan" isRequired={true} />
                        

                        <ControlledInput control={control} name="emailKantor" label="Email Kantor" isRequired={true} />
                        </div>
                        <div className="col-span-2">
                        <Controller
                            control={control}
                            name="tipePerusahaan"
                            render={({ field, fieldState }) => (
                                <CheckboxGroup 
                                    {...field} 
                                    label="Tipe Perusahaan" 
                                    isRequired={true} 
                                    isInvalid={fieldState.invalid} 
                                    errorMessage={fieldState.error?.message}
                                >
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                        <Checkbox size="sm" value="Menggunakan B3">Menggunakan B3</Checkbox>
                                        <Checkbox size="sm" value="Distribusi B3">Distribusi B3</Checkbox>
                                    </div>
                                </CheckboxGroup>
                            )}
                        />
                    </div>

                    {/* Skala Perusahaan hanya tampil jika tipe perusahaan mencakup "Perusahaan Distributor" */}
                    {tipePerusahaan?.includes("Distribusi B3") && (
                        <ControlledReactSelect
                            control={control}
                            name="skalaPerusahaan"
                            label="Skala Perusahaan"
                            
                            isMulti={false}
                            isLoading={false}
                            options={[
                                { value: 'Mikro', label: 'Mikro' },
                                { value: 'Kecil', label: 'Kecil' },
                                { value: 'Menengah', label: 'Menengah' },
                                { value: 'Besar', label: 'Besar' },
                                { value: 'Kantor perwakilan', label: 'Kantor Perwakilan' },
                                { value: 'Badan usaha luar negeri', label: 'Badan Usaha Luar Negeri' },
                            ]}
                            className="col-span-2 md:col-span-1"
                        />
                    )}

                        <Textarea
                            {...register('alamatKantor')}
                            isRequired
                            variant="faded"
                            type="text"
                            label="Alamat Kantor"
                            labelPlacement="outside"
                            color={errors.alamatKantor ? 'danger' : 'default'}
                            isInvalid={errors.alamatKantor}
                            errorMessage={errors.alamatKantor && errors.alamatKantor.message}
                            fullWidth
                            disableAutosize
                        />
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 gap-4 mb-5">
                        <ControlledInput control={control} name="telpKantor" label="Telepon Kantor" isRequired={true} />
                        <ControlledInput control={control} name="faxKantor" label="Fax Kantor" isRequired={true} />
                        <ControlledInput control={control} name="npwp" label="NPWP" isRequired={true} />
                        <ControlledInput control={control} name="bidangUsaha" label="Bidang Usaha" isRequired={true} />
                        <ControlledInput control={control} name="nomorInduk" label="Nomor Induk" isRequired={true} />
                        <ControlledInput label="Latitude" name="latitude" type="text" isRequired={true} control={control} />
                        <ControlledInput label="Longitude" name="longitude" type="text" isRequired={true} control={control} />  
                        <Select
                            {...register('provinceId')}
                            isRequired
                            variant="faded"
                            label="Provinsi"
                            labelPlacement="outside"
                            placeholder='Pilih...'
                            onChange={(e) => setValue('provinceId', e.target.value)}
                            color={errors.provinceId ? 'danger' : 'default'}
                            isInvalid={errors.provinceId}
                            errorMessage={errors.provinceId && errors.provinceId.message}
                        >
                            {province?.map(item => (
                                <SelectItem key={item.id} value={item.id}>{item.name}</SelectItem>
                            ))}
                        </Select>                    
                        <Select
                            {...register('regencyId')}
                            isRequired
                            variant="faded"
                            label="Kabupaten"
                            labelPlacement="outside"
                            placeholder='Pilih...'
                            onChange={(e) => setValue('regencyId', e.target.value)}
                            color={errors.regencyId ? 'danger' : 'default'}
                            isInvalid={errors.regencyId}
                            errorMessage={errors.regencyId && errors.regencyId.message}
                        >
                            {regency?.map(item => (
                                <SelectItem key={item.id}>{item.name}</SelectItem>
                            ))}
                        </Select>                    
                        <Select
                            {...register('districtId')}
                            isRequired
                            variant="faded"
                            label="Kecamatan"
                            labelPlacement="outside"
                            placeholder='Pilih...'
                            onChange={(e) => setValue('districtId', e.target.value)}
                            color={errors.districtId ? 'danger' : 'default'}
                            isInvalid={errors.districtId}
                            errorMessage={errors.districtId && errors.districtId.message}
                        >
                            {district?.map(item => (
                                <SelectItem key={item.id}>{item.name}</SelectItem>
                            ))}
                        </Select>                    
                        <Select
                            {...register('villageId')}
                            isRequired
                            variant="faded"
                            label="Kelurahan"
                            labelPlacement="outside"
                            placeholder='Pilih...'
                            color={errors.villageId ? 'danger' : 'default'}
                            isInvalid={errors.villageId}
                            errorMessage={errors.villageId && errors.villageId.message}
                        >
                            {village?.map(item => (
                                <SelectItem key={item.id}>{item.name}</SelectItem>
                            ))}
                        </Select>
                        </div>
                    </div>
                    <div>
                        <h4 className="text-lg font-bold">Data Direktur</h4>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 gap-4 mb-5">
                        <ControlledInput control={control} name="namaPenanggungJawab" label="Nama Direktur" isRequired={true} />
                        <ControlledInput control={control} name="jabatan" label="Jabatan" isRequired={true} />
                        <ControlledInput control={control} name="emailDirektur" label="Email Direktur" isRequired={true} />
                        <ControlledInput control={control} name="teleponDirektur" label="Telepon Direktur" isRequired={true} />
                        <ControlledInput control={control} name="alamatDirektur" label="Alamat Direktur" isRequired={true} />
                    </div>
                    </div>
                    <div className='"grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 gap-4 mb-5"'>
                    <Controller
                        control={control}
                        name="attachments"
                        rules={{
                            required: 'File is required',
                            validate: {
                                isPdf: (files) => {
                                    // Check if the file is a PDF
                                    return files[0]?.type === 'application/pdf' || 'File must be a PDF';
                                },
                                maxSize: (files) => {
                                    // Check if the file is less than or equal to 2 MB
                                    return files[0]?.size <= 2 * 1024 * 1024 || 'File size must be less than 2 MB';
                                },
                            },
                        }}
                        render={({ field: { value, onChange, ...field } }) => {
                            return (
                                <Input
                                    {...field}
                                    color={errors.attachments ? 'danger' : 'default'}
                                    isInvalid={errors.attachments}
                                    errorMessage={errors.attachments && errors.attachments.message}
                                    radius="sm"
                                    label="Formulir Pendaftaran (Max 2 MB PDF)"
                                    labelPlacement="outside"
                                    type="file"
                                    accept=".pdf"  // Only PDF files will be shown in the file dialog
                                    size="md"
                                    onChange={(e) => {
                                        onChange([...e.target.files]); // Ensure the value is updated with the file list
                                    }}
                                />
                            );
                        }}
                    />
                    <Button radius="sm" color="primary" size="md" className='mt-4 mb-4' > Unduh Formulir Pendaftaran</Button>
                    </div>
                    <Button isLoading={isSubmitting} isDisabled={isSubmitting} type='submit' radius="sm" color="primary" size="md" className="w-full">Daftar</Button>
                </form>
            </div>
        </RootAuth>
    )
};
